<template>
  <section class="section pos-section">
    <div class="columns is-gapless">
      <!-- Main POS Area -->
      <div class="column is-9 pr-4">
        <div class="glass-container-pos animate__animated animate__fadeIn">
          <div class="is-flex is-justify-content-between is-align-items-center mb-5">
            <h1 class="title is-3 has-text-white mb-0">Punto de Venta</h1>
            <buscar-producto @seleccionado="onSeleccionado" class="glass-search" />
          </div>

          <mensaje-inicial-dos
            :titulo="'Escanee algunos productos o escriba el nombre para buscarlos.'"
            :subtitulo="'F8 Para añadir gastos y/o entradas'"
            v-if="productos.length < 1"
          />

          <div v-if="productos.length > 0" class="table-container glass-table">
            <tabla-productos
              :listaProductos="productos"
              @quitar="onQuitar"
              @otp2="otp2"
              @otp3="otp3"
              @aumentar="onAumentar"
              @cambiarPrecio="cambiarPrecio"
            />
          </div>
        </div>
      </div>

      <!-- Totals Overlay Sidebar -->
      <div class="column is-3">
        <div class="glass-sidebar shadow-premium animate__animated animate__slideInRight">
          <div class="summary-header has-text-centered mb-6">
            <p class="has-text-grey-lighter is-size-6 uppercase tracking-widest has-text-weight-bold">Total a Pagar</p>
            <h2 class="title is-1 has-text-white mt-2 mb-4 total-text">
              ${{ parseFloat(total).toLocaleString("es-CO") }}
            </h2>
          </div>

          <div class="buttons-stack">
            <b-button
              expanded
              type="is-primary"
              size="is-large"
              icon-left="check-circle"
              class="is-rounded glass-btn-primary mb-4"
              @click="abrirDialogo('venta')"
              :disabled="productos.length === 0"
            >
              Terminar Venta
            </b-button>

            <div class="columns is-mobile is-multiline">
              <div class="column is-full">
                <b-button
                  expanded
                  type="is-info"
                  icon-left="account-plus"
                  class="is-rounded glass-btn-secondary mb-2"
                  @click="abrirDialogo('cuenta')"
                  :disabled="productos.length === 0"
                >
                  A Cuenta
                </b-button>
              </div>
              <div class="column is-full">
                <b-button
                  expanded
                  type="is-danger"
                  icon-left="close-circle"
                  class="is-rounded glass-btn-danger"
                  @click="cancelarVenta"
                  :disabled="productos.length === 0"
                >
                  Cancelar
                </b-button>
              </div>
            </div>
          </div>

          <div class="pos-shortcuts mt-6 pt-6 has-border-top">
            <p class="has-text-grey-light is-size-7 mb-2">Atajos de teclado:</p>
            <div class="is-flex is-justify-content-between mb-1">
              <span class="has-text-grey-light is-size-7">F12</span>
              <span class="has-text-white is-size-7">Terminar</span>
            </div>
            <div class="is-flex is-justify-content-between mb-1">
              <span class="has-text-grey-light is-size-7">F7</span>
              <span class="has-text-white is-size-7">Buscar</span>
            </div>
            <div class="is-flex is-justify-content-between">
              <span class="has-text-grey-light is-size-7">F8</span>
              <span class="has-text-white is-size-7">Gastos</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
    
    <b-modal
      v-model="mostrarDialogo"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <dialogo-terminar-venta
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        @terminarsinf="onTerminarsinf"
        v-if="mostrarTerminarVenta"
      />
      <dialogo-agregar-cuenta
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarAgregarCuenta"
      />
      <dialogo-agregar-apartado
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarAgregarApartado"
      />
      <dialogo-cotizar
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarRegistrarCotizacion"
      />
    </b-modal>

    <comprobante-compra
      :venta="this.ventaRealizada"
      :tipo="tipoVenta"
      :ultimoId="ultimoId"
      :cufe="cufe"
      @impreso="onImpreso"
      v-if="mostrarComprobante"
    />

    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner"></div>
        <p class="has-text-white mt-4">Procesando Factura Electrónica...</p>
      </div>
    </div>
  </section>
</template>
 
<script>
import BuscarProducto from "../Inventario/BuscarProducto.vue";
import TablaProductos from "./TablaProductos.vue";
import DialogoTerminarVenta from "./DialogoTerminarVenta";
import DialogoAgregarCuenta from "./DialogoAgregarCuenta";
import DialogoAgregarApartado from "./DialogoAgregarApartado";
import DialogoCotizar from "./DialogoCotizar";
import ComprobanteCompra from "./ComprobanteCompra";
import MensajeInicialDos from "../Extras/MensajeInicialDos";
import AyudanteSesion from "../../Servicios/AyudanteSesion";
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";

export default {
  mixins: [NotificacionesMixin],
  name: "RealizarVenta",
  components: {
    BuscarProducto,
    TablaProductos,
    DialogoTerminarVenta,
    DialogoAgregarCuenta,
    DialogoAgregarApartado,
    DialogoCotizar,
    MensajeInicialDos,
    ComprobanteCompra,
  },

  data: () => ({
    componenteColor: "#8CC9F6",
    cargando: false,
    productos: [],
    total: 0,
    mostrarDialogo: false,
    mostrarTerminarVenta: false,
    mostrarAgregarCuenta: false,
    mostrarAgregarApartado: false,
    mostrarRegistrarCotizacion: false,
    ventaRealizada: null,
    mostrarComprobante: false,
    tipoVenta: "",
    processingVenta: false,
    ganancia: 0,
    datosNegocio: {},
    ultimoId: "",
    token: "",
    datosFactura: {}, //
    numeroActualFactura: "",
    loading: false, // Controla la pantalla de carga
    cufe: "",
    errorMessage: "",
  }),

  methods: {
    async traerDatos() {
      try {
        let payload = {
          accion: "obtenerDatosFacturador",
        };

        let datos = await HttpService.obtenerConConsultas(
          "facturas.php",
          payload
        );

        if (Array.isArray(datos) && datos.length > 0) {
          this.datosFactura = datos[0]; // ✅ Tomamos el primer elemento
          this.token = datos[0].token; // ✅ Ahora asignamos el token correctamente
          this.numeroActualFactura = datos[0].number;
        } else {
          this.mostrarNotificacion(
            "error",
            "No se pudo obtener datos de facturación"
          );
        }
      } catch (error) {
        console.error("Error al obtener los datos de facturación:", error);
        this.mostrarNotificacion("error", "Error comunicando con el servidor");
      }
    },
    async enviarFacturaElectronica(venta, paymentMethod) {
      this.loading = true; // 🔹 Bloquea la pantalla al iniciar
      try {
        const now = new Date();
        now.setHours(now.getHours() - 5); // Restar 5 horas para Bogotá

        const fecha = now.toISOString().split("T")[0];
        const hora = now.toTimeString().split(" ")[0];

        // 🔹 Construir el objeto de factura
        let invoiceData = {
          ID_SOFT_FE: this.datosFactura.ID_SOFT_FE, // ID de facturación
          number: this.numeroActualFactura,
          type_document_id: 1, // Tipo de documento (Factura electrónica)
          date: fecha,
          time: hora,
          resolution_number: this.datosFactura.resolution_number,
          prefix: this.datosFactura.prefix,
          notes:
            "Factura electrónica emitida conforme a la resolución de la DIAN.",
          sendmail: this.datosFactura.sendmail == 1 ? true : false,
          head_note: "Factura electrónica validada por la DIAN.",
          foot_note:
            "Gracias por su compra. Esta factura es válida electrónicamente.",

          // 🔹 Forma de pago
          payment_form: {
            payment_form_id: 1,
            payment_method_id: paymentMethod,
            payment_due_date: fecha,
            duration_measure: "0",
          },

          // 🔹 Totales legales
          legal_monetary_totals: {
            line_extension_amount: (Number(venta.total) || 0).toFixed(2),
            tax_exclusive_amount: "0",
            tax_inclusive_amount: (Number(venta.total) || 0).toFixed(2),
            allowance_total_amount: "0",
            payable_amount: (Number(venta.total) || 0).toFixed(2),
          },

          // 🔹 Detalles de los productos vendidos
          invoice_lines: venta.productos.map((producto) => ({
            unit_measure_id: 70,
            invoiced_quantity: producto.cantidad.toString(),
            line_extension_amount: (
              parseFloat(producto.cantidad) * parseFloat(producto.precio)
            ).toFixed(2),
            free_of_charge_indicator: false,
            description: producto.nombre,
            code: producto.codigo,
            type_item_identification_id: 4,
            price_amount: parseFloat(producto.precio).toFixed(2),
            base_quantity: "1",
          })),
        };

        // 🔹 Solo agregar cliente si hay datos
        if (venta.cliente && Object.keys(venta.cliente).length > 0) {
          invoiceData.customer = { ...venta.cliente };
        }

        // 🔹 Enviar la factura
        const response = await fetch(
          "https://api.nextpyme.plus/api/ubl2.1/invoice",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
              Accept: "application/json",
            },
            body: JSON.stringify(invoiceData),
          }
        );

        const result = await response.json();
        // 🔹 Verificar validez de la respuesta
        let isValid =
          result.ResponseDian &&
          result.ResponseDian.Envelope &&
          result.ResponseDian.Envelope.Body &&
          result.ResponseDian.Envelope.Body.SendBillSyncResponse &&
          result.ResponseDian.Envelope.Body.SendBillSyncResponse
            .SendBillSyncResult &&
          result.ResponseDian.Envelope.Body.SendBillSyncResponse
            .SendBillSyncResult.IsValid === "true";

        if (!isValid) {
          this.errorMessage= result.ResponseDian.Envelope.Body.SendBillSyncResponse
          .SendBillSyncResult.ErrorMessage.string
          this.loading = false; // 🔹 Desbloquear pantalla
          this.guardarFacturaBackend(result);
          return false;
        }

        // 🔹 Si todo está OK
        this.aumentarNumber();
        this.cufe = result.cufe;
        this.loading = false;

        // Retornar éxito
        return { success: true, message: "Factura generada con éxito" };
      } catch (error) {
        console.error("Error al enviar factura electrónica:", error);
        this.loading = false;
        // Retornar objeto con éxito=false y mensaje genérico
        return { success: false, message: this.errorMessage };
      }
    },

    async onTerminar(venta) {
      if (!this.processingVenta) {
        this.ventaRealizada = {
          total: this.total,
          productos: this.productos,
          ganancia: this.ganancia,
          cliente:
            venta.tipo === "venta" &&
            venta.cliente &&
            Object.keys(venta.cliente).length > 0
              ? venta.cliente
              : venta.cliente.id,
          usuario: AyudanteSesion.obtenerDatosSesion().id,
          nombreCliente: venta.cliente.nombre
            ? venta.cliente.nombre
            : "Publico General",
          nombreUsuario: AyudanteSesion.obtenerDatosSesion().usuario,
          fecha: new Date()
            .toLocaleString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })
            .replace(",", ""),
          nit: venta.cliente.nit,
          direccion: venta.cliente.direccion,
          telefono: venta.cliente.telefono,
          correo: venta.cliente.correo,
        };

        let tipo = venta.tipo;

        switch (tipo) {
          case "venta": {
            this.ventaRealizada.tipo = "venta";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.cambio = parseInt(venta.cambio);
            this.ventaRealizada.efectivo = parseInt(venta.efectivo);
            this.ventaRealizada.tarjeta = venta.tarjeta;
            this.ventaRealizada.transferencia = venta.transferencia;
            this.ventaRealizada.nequi = venta.nequi;
            // 🔹 Seleccionar método de pago
            let selectedPaymentMethod = 10; // Por defecto: efectivo
            const pagos = [
              { id: 10, valor: Number(venta.efectivo) },
              { id: 49, valor: Number(venta.tarjeta) },
              { id: 31, valor: Number(venta.transferencia) },
              { id: 75, valor: 0 },
            ];

            let pagosUsados = pagos.filter((pago) => pago.valor > 0);
            if (pagosUsados.length > 1) {
              selectedPaymentMethod = 75;
            } else if (pagosUsados.length === 1) {
              selectedPaymentMethod = pagosUsados[0].id;
            }

            // 🔹 Si hay cliente, enviar factura electrónica antes de registrar la venta
            if (venta.cliente && Object.keys(venta.cliente).length > 0) {
              const respuesta = await this.enviarFacturaElectronica(
                this.ventaRealizada,
                selectedPaymentMethod
              );

              // 🔹 Revisar la respuesta de la factura
              if (!respuesta.success) {
                // Mostrar error (mensaje detallado de la DIAN o genérico)
                Swal.fire({
                  title: "Error",
                  text: respuesta.message,
                  icon: "error",
                  confirmButtonText: "OK",
                });
                return; // ❌ Detener proceso
              }
            }
            break;
          }

          case "cuenta": {
            this.ventaRealizada.tipo = "cuenta";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.porPagar = venta.porPagar;
            break;
          }

          case "apartado": {
            this.ventaRealizada.tipo = "apartado";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.porPagar = venta.porPagar;
            break;
          }

          case "cotiza": {
            this.ventaRealizada.tipo = "cotiza";
            break;
          }
        }

        this.tipoVenta = venta.tipo;

        // 🔹 Registrar venta
        let datos = {
          accion: "vender",
          datos: this.ventaRealizada,
          cufe:this.cufe,
        };

        HttpService.registrar("vender.php", datos).then((registrado) => {
          if (registrado && registrado.success) {
            // Almacenar el ID de la venta en this.ultimoId
            this.ultimoId = registrado.idVenta;

            // Limpiar productos y totales
            this.productos = [];
            this.total = 0;

            // Ocultar modales y notificaciones
            this.mostrarTerminarVenta =
              this.mostrarAgregarCuenta =
              this.mostrarAgregarApartado =
              this.mostrarRegistrarCotizacion =
                false;

            this.mostrarDialogo = false;

            // Mostrar notificación de éxito
            this.mostrarNotificacion("success", `Venta Realizada Con éxito`);

            // Mostrar el comprobante con el ID recién almacenado
            this.mostrarComprobante = true;
          } else {
            // Manejo de error en caso de que la venta no se registre correctamente
            this.mostrarNotificacion("error", `Error al realizar la venta`);
          }
        });
      }
    },

    onTerminarsinf(venta) {
      this.traerDatos();
      if (!this.processingVenta) {
        this.ventaRealizada = {
          total: this.total,
          productos: this.productos,
          cliente: venta.cliente.id,
          ganancia: this.ganancia,
          usuario: AyudanteSesion.obtenerDatosSesion().id,
          nombreCliente: venta.cliente.nombre
            ? venta.cliente.nombre
            : "Publico General",
          nombreUsuario: AyudanteSesion.obtenerDatosSesion().usuario,
          fecha: new Date()
            .toLocaleString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })
            .replace(",", ""),
        };

        let tipo = venta.tipo;

        switch (tipo) {
          case "venta":
            this.ventaRealizada.tipo = "venta";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.cambio = parseInt(venta.cambio);
            this.ventaRealizada.efectivo = parseInt(venta.efectivo);
            this.ventaRealizada.tarjeta = venta.tarjeta;
            this.ventaRealizada.transferencia = venta.transferencia;
            this.ventaRealizada.nequi = venta.nequi;

            break;
          case "cuenta":
            this.ventaRealizada.tipo = "cuenta";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.porPagar = venta.porPagar;

            break;
          case "apartado":
            this.ventaRealizada.tipo = "apartado";
            this.ventaRealizada.pagado = venta.pagado;
            this.ventaRealizada.porPagar = venta.porPagar;

            break;
          case "cotiza":
            this.ventaRealizada.tipo = "cotiza";

            break;
        }

        this.tipoVenta = venta.tipo;

        // this.cargando = true;
        let datos = {
          accion: "vender",
          datos: this.ventaRealizada,
        };

        HttpService.registrar("vender.php", datos).then((registrado) => {
          if (registrado) {
            this.productos = [];
            this.total = 0;
            // this.cargando = false;
            this.mostrarTerminarVenta =
              this.mostrarAgregarCuenta =
              this.mostrarAgregarApartado =
              this.mostrarRegistrarCotizacion =
                false;
            this.mostrarDialogo = false;
            this.mostrarNotificacion("success", `Registrado correctamente`);

            window.location.reload();
          }
        });
      }
    },

    guardarFacturaBackend(facturaData) {
      let payload = {
        accion: "registrarDocumento",
        facturaData: facturaData,
      };
      HttpService.registrar("facturas.php", payload).then((registrado) => {
        if (registrado) {
          console.log(registrado);
        }
      });
    },
    aumentarNumber() {
      let payload = {
        accion: "aumentarNumber",
      };
      HttpService.registrar("facturas.php", payload).then((registrado) => {
        if (registrado) {
          console.log(registrado);
        }
      });
    },
    handleKeyPress(event) {
      // Verifica si la tecla presionada es F7 (código de tecla 118)
      if (event.keyCode === 118) {
        document.querySelector("#producto").focus();
      }

      // Verifica si la tecla presionada es F8 (código de tecla 119)
      if (event.keyCode === 119) {
        // Llama a la función para abrir el diálogo de swal
        this.abrirDialogoSwal();
      }
    },

    abrirDialogoSwal() {
      // Utiliza swal para mostrar un diálogo de selección
      Swal.fire({
        title: "Seleccione",
        input: "select",
        inputOptions: {
          entrada: "Entrada de dinero",
          salida: "Salida de dinero",
        },
        inputPlaceholder: "Seleccione una opción",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Siguiente &rarr;",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value === "entrada" || value === "salida") {
              // Si la opción seleccionada es válida, pide más información
              this.pedirMotivoYValor(value);
            } else {
              resolve("Debe seleccionar una opción válida");
            }
          });
        },
      });
    },

    pedirMotivoYValor(tipoMovimiento) {
      // Define una clase específica para el fondo según el tipo de movimiento
      const fondoClase =
        tipoMovimiento === "entrada" ? "fondo-verde" : "fondo-rojo";

      Swal.fire({
        title: tipoMovimiento.charAt(0).toUpperCase() + tipoMovimiento.slice(1), // Coloca el tipo de movimiento como título
        html:
          '<label for="motivo">Motivo:</label>' +
          '<input id="motivo" class="swal2-input" placeholder="Ingrese el motivo" />' +
          "<br>" +
          '<label for="valor">Valor:</label>' +
          '<input id="valor" class="swal2-input" placeholder="Ingrese el valor" />',
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
        preConfirm: () => {
          const motivo = Swal.getPopup().querySelector("#motivo").value;
          const valor = Swal.getPopup().querySelector("#valor").value;

          if (!motivo || !valor) {
            Swal.showValidationMessage("Ambos campos son obligatorios");
          }

          return { motivo: motivo, valor: valor };
        },
        customClass: {
          container: fondoClase, // Aplica el fondo específico según el tipo de movimiento
          popup: "fondo-popup",
        },
      }).then((result) => {
        if (!result.dismiss) {
          const usuario = localStorage.getItem("nombreUsuario");

          const { motivo, valor } = result.value;
          let payload = {
            accion: "registrarTransacción",
            motivo: motivo,
            valor: valor,
            nombreUsuario: usuario,
            tipoMovimiento: tipoMovimiento,
          };
          HttpService.registrar("vender.php", payload).then((registrado) => {
            if (registrado) {
              this.$buefy.toast.open({
                type: "is-info",
                message: "Registrado con éxito.",
              });
            }
          });
          // Realiza las operaciones necesarias con los datos ingresados
        }
      });
    },

    handleKeydown(event) {
      if (event.keyCode === 123) {
        //123 F12
        this.abrirDialogo("venta");
      }
      if (event.keyCode === 46) {
        //tecla suprimir
        this.cancelarVenta();
      }
    },
    abrirDialogo(opcion) {
      this.mostrarDialogo = true;
      switch (opcion) {
        case "venta":
          this.mostrarTerminarVenta = true;
          this.mostrarAgregarCuenta =
            this.mostrarAgregarApartado =
            this.mostrarRegistrarCotizacion =
              false;
          break;
        case "cuenta":
          this.mostrarAgregarCuenta = true;
          this.mostrarTerminarVenta =
            this.mostrarAgregarApartado =
            this.mostrarRegistrarCotizacion =
              false;
          break;
        case "apartado":
          this.mostrarAgregarApartado = true;
          this.mostrarAgregarCuenta =
            this.mostrarTerminarVenta =
            this.mostrarRegistrarCotizacion =
              false;
          break;
        case "cotiza":
          this.mostrarRegistrarCotizacion = true;
          this.mostrarAgregarCuenta =
            this.mostrarTerminarVenta =
            this.mostrarAgregarApartado =
              false;
          break;
      }
    },
    onImpreso(resultado) {
      this.mostrarComprobante = resultado;
      if (resultado === false) {
        setTimeout(() => {
          window.location.reload();
        }, 1600); // 1000 milisegundos (1.6 segundo)
      }
    },
    cancelarVenta() {
      this.$buefy.dialog.confirm({
        title: "Cancelar venta",
        message: "¿Seguro que deseas cancelar la venta?",
        confirmText: "Sí, cancelar",
        cancelText: "No, continuar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.productos = [];
          this.total = 0;
          this.mostrarNotificacion("success", `Venta Cancelada`);
        },
      });
    },

    onCerrar(opcion) {
      this.mostrarDialogo = false;
      if (
        opcion === "venta" ||
        opcion === "cuenta" ||
        opcion === "apartado" ||
        opcion === "cotiza"
      )
        this.mostrarTerminarVenta =
          this.mostrarAgregarCuenta =
          this.mostrarAgregarApartado =
          this.mostrarRegistrarCotizacion =
            false;
    },

    onQuitar(id) {
      let indice = this.productos.findIndex((producto) => producto.id === id);
      this.productos.splice(indice, 1);
      this.total = this.calcularTotal();
    },

    otp2(producto) {
      producto.precio = producto.precio2;
      this.mostrarNotificacion(
        "success",
        "precio 2 aplicado a  " + producto.nombre
      );
      this.total = this.calcularTotal();
    },
    otp3(producto) {
      producto.precio = producto.precio3;
      this.mostrarNotificacion(
        "success",
        "precio 3 aplicado a  " + producto.nombre
      );
      this.total = this.calcularTotal();
    },
    cambiarPrecio(producto) {
      const precioVenta = producto.precio;
      const precioCompra = producto.precioCompra;

      Swal.fire({
        title: "Cambiar Precio",
        html: `
          <label for="newPrice">Precio actual: $${precioVenta}</label><br>
          <label for="precioCompra">Precio de compra: $${precioCompra}</label><br>
          <input type="number" id="newPrice" class="swal2-input" placeholder="Nuevo precio" min="0" step="0.01">
          <br>
          <label id="discountLabel">Descuento: 0%</label>
        `,
        inputAttributes: {
          min: 0,
          step: 0.01,
        },
        showCancelButton: true,
        confirmButtonText: "Cambiar precio",
        preConfirm: () => {
          const newPrice = document.getElementById("newPrice").value;
          if (newPrice && newPrice >= 0) {
            return newPrice;
          } else {
            Swal.showValidationMessage("Por favor, ingresa un precio válido.");
          }
        },
        didOpen: () => {
          const input = document.getElementById("newPrice");
          const discountLabel = document.getElementById("discountLabel");

          input.addEventListener("input", () => {
            const newPrice = parseFloat(input.value);
            const discount = ((precioVenta - newPrice) / precioVenta) * 100;
            discountLabel.textContent = `Descuento: ${discount.toFixed(2)}%`;
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const nuevoPrecio = result.value;
          producto.precio = nuevoPrecio; // Aquí se actualiza el precio del producto
          this.mostrarNotificacion(
            "success",
            "Precio Actualizado de " + producto.nombre
          );
        }
        this.total = this.calcularTotal();
      });
    },

    onAumentar(producto) {
      let verificaExistencia = this.verificarExistenciaAlcanzada(
        producto.existencia,
        producto.id
      );

      if (verificaExistencia) return;

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(
          producto.cantidadMayoreo,
          producto.id,
          producto.precioMayoreo
        );
      }
      this.total = this.calcularTotal();
    },

    onSeleccionado(producto) {
      let verificaExistencia = this.verificarExistenciaAlcanzada(
        producto.existencia,
        producto.id
      );

      if (verificaExistencia) return;

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(
          producto.cantidadMayoreo,
          producto.id,
          producto.precioMayoreo
        );
      }

      let existeEnLista = this.verificarSiEstaEnLista(producto.id);

      if (existeEnLista >= 0) {
        this.aumentarCantidad(existeEnLista);
        this.total = this.calcularTotal();
        return;
      }

      this.agregarALista(producto);
      this.total = this.calcularTotal();
    },
    agregarALista(producto) {
      if (producto.peso === 1) {
        if (producto.peso !== null && producto.peso !== undefined) {
          Swal.fire({
            title: `Ingrese el peso para - ${producto.nombre}`,
            input: "number",
            inputPlaceholder: `Precio de venta 1 - $${parseInt(
              producto.precioVenta
            ).toLocaleString("es-CO")}`,
            confirmButtonText: "Aceptar",
            inputValidator: (value) => {
              if (!value || value <= 0) {
                return "Por favor, ingrese un peso válido";
              }
            },
          }).then((result) => {
            if (result.isConfirmed) {
              const peso = parseFloat(result.value);

              // Verificación de inventario
              if (
                this.datosNegocio.usarInventario === 1 &&
                peso > producto.existencia
              ) {
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: `El producto ${producto.nombre} ha alcanzado la existencia máxima. Solo tienes ${producto.existencia}.`,
                });
                return; // Salir del método si el peso es mayor a la existencia
              }

              const cantidad = peso;

              // Verificación de mayoreo antes de agregar el producto
              if (
                producto.vendidoMayoreo === 1 &&
                cantidad >= producto.cantidadMayoreo
              ) {
                Swal.fire({
                  title: "¿Aplicar precio de mayoreo?",
                  text: `El producto ${
                    producto.nombre
                  } tiene mayoreo a partir de ${
                    producto.cantidadMayoreo
                  } unidades. ¿Desea aplicar el precio de mayoreo de $${producto.precioMayoreo.toLocaleString(
                    "es-CO"
                  )}?`,
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonText: "Sí, aplicar",
                  cancelButtonText: "No aplicar",
                }).then((response) => {
                  let precioAplicado = producto.precioVenta;
                  let mayoreoAplicado = false;

                  if (response.isConfirmed) {
                    precioAplicado = producto.precioMayoreo;
                    mayoreoAplicado = true;
                    this.mostrarNotificacion(
                      "success",
                      `Precio Mayoreo aplicado`
                    );
                  }

                  // Agregar el producto a la lista con el precio correcto
                  this.productos.push({
                    id: producto.id,
                    codigo: producto.codigo,
                    nombre: producto.nombre,
                    precio: precioAplicado,
                    precio2: producto.precioVenta2,
                    precio3: producto.precioVenta3,
                    cantidad: cantidad,
                    existencia: producto.existencia,
                    vendidoMayoreo: producto.vendidoMayoreo,
                    cantidadMayoreo: producto.cantidadMayoreo,
                    precioMayoreo: producto.precioMayoreo,
                    mayoreoAplicado: mayoreoAplicado,
                    peso: producto.peso,
                    precioCompra: producto.precioCompra,
                  });

                  // Actualizamos el total
                  this.total = this.calcularTotal();
                });
              } else {
                // Si no aplica mayoreo, se agrega directamente el producto
                this.productos.push({
                  id: producto.id,
                  codigo: producto.codigo,
                  nombre: producto.nombre,
                  precio: producto.precioVenta,
                  precio2: producto.precioVenta2,
                  precio3: producto.precioVenta3,
                  cantidad: cantidad,
                  existencia: producto.existencia,
                  vendidoMayoreo: producto.vendidoMayoreo,
                  cantidadMayoreo: producto.cantidadMayoreo,
                  precioMayoreo: producto.precioMayoreo,
                  mayoreoAplicado: false,
                  peso: producto.peso,
                  precioCompra: producto.precioCompra,
                });

                // Actualizamos el total
                this.total = this.calcularTotal();
              }
            }
          });
        }
      } else {
        // Verificación de inventario para productos sin peso
        if (this.datosNegocio.usarInventario === 1 && 1 > producto.existencia) {
          this.$buefy.toast.open({
            type: "is-danger",
            message: `El producto ${producto.nombre} ha alcanzado la existencia máxima. Solo tienes ${producto.existencia}.`,
          });
          return; // Salir del método si la cantidad es mayor a la existencia
        }
        // Agregar el producto directamente si no hay verificación de inventario
        this.productos.push({
          id: producto.id,
          codigo: producto.codigo,
          nombre: producto.nombre,
          precio: producto.precioVenta,
          precio2: producto.precioVenta2,
          precio3: producto.precioVenta3,
          cantidad: 1,
          existencia: producto.existencia,
          vendidoMayoreo: producto.vendidoMayoreo,
          cantidadMayoreo: producto.cantidadMayoreo,
          precioMayoreo: producto.precioMayoreo,
          mayoreoAplicado: false,
          peso: producto.peso,
          precioCompra: producto.precioCompra,
        });
      }
    },

    verificarExistenciaAlcanzada(existencia, id) {
      let resultado = false;

      // Verifica si se debe usar el inventario o actuar como si siempre hubiera suficiente inventario
      if (this.datosNegocio.usarInventario === 0) {
        return false; // Si no se usa inventario, siempre devuelve `false` (no alcanzó el máximo)
      }
      // Procede con la verificación de inventario si `usarInventario` es `1`
      this.productos.forEach((producto) => {
        if (producto.id === id) {
          if (parseFloat(producto.cantidad) > parseFloat(existencia)) {
            this.$buefy.toast.open({
              type: "is-danger",
              message:
                "El producto " +
                producto.nombre +
                " ha alcanzado la existencia máxima. Solo tienes " +
                producto.existencia,
            });
            producto.cantidad = existencia;
            resultado = true;
          }
          this.total = this.calcularTotal();
        }
      });

      return resultado;
    },

    verificarMayoreo(cantidadMayoreo, id, precioMayoreo) {
      this.productos.forEach((producto) => {
        if (producto.mayoreoAplicado) return;
        if (producto.id === id) {
          if (producto.cantidad >= parseInt(cantidadMayoreo)) {
            this.$buefy.dialog.confirm({
              confirmText: "Sí, aplicar",
              cancelText: "No aplicar",
              message:
                "El producto " +
                producto.nombre +
                " tiene mayoreo a partir de " +
                cantidadMayoreo +
                " piezas, ¿Desea aplicar el mayoreo?",
              onConfirm: () => {
                producto.precio = precioMayoreo;
                producto.mayoreoAplicado = true;
                this.$buefy.toast.open(
                  "Mayoreo aplicado correctamente a " + producto.nombre
                );
                this.total = this.calcularTotal();
              },
            });
          }
        }
      });
    },

    verificarSiEstaEnLista(id) {
      return this.productos.findIndex((producto) => producto.id === id);
    },

    aumentarCantidad(indice) {
      let lista = this.productos;
      let producto = lista[indice];
      producto.cantidad++;
      this.productos = lista;
    },

    calcularTotal() {
      let total = 0;
      let ganancia = 0;
      this.productos.forEach((producto) => {
        total =
          parseFloat(producto.cantidad * producto.precio) + parseFloat(total);
      });
      this.productos.forEach((producto) => {
        ganancia +=
          parseFloat(producto.cantidad * producto.precio) -
          parseFloat(producto.cantidad * producto.precioCompra);
      });
      this.ganancia = ganancia;
      return total.toFixed(0);
    },
    obtenerInformacionLocal() {
      HttpService.obtenerConConsultas("ajustes.php", {
        accion: "obtener",
      }).then((resultado) => {
        this.datosNegocio = resultado;
      });
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyPress);
    this.obtenerInformacionLocal();
    document.addEventListener("keydown", this.handleKeydown);
    document.title = "Vender"; // Cambia el título al montar el componente
    this.traerDatos();
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyPress);
    document.title = "pos";
  },
};
</script>

<style scoped>
.pos-section {
  padding-top: 10px;
}

.glass-container-pos {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80vh;
}

.glass-sidebar {
  background: rgba(43, 43, 43, 0.9);
  backdrop-filter: blur(25px);
  border-radius: 24px;
  padding: 40px 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 100%;
  position: sticky;
  top: 10px;
  display: flex;
  flex-direction: column;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  color: #00d1b2 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: transparent !important;
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
}

.total-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  letter-spacing: -2px;
  text-shadow: 0 0 20px rgba(0, 209, 178, 0.4);
}

.glass-btn-primary {
  background: linear-gradient(135deg, #00d1b2 0%, #009e86 100%);
  border: none;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(0, 209, 178, 0.3);
  transition: all 0.3s ease;
}

.glass-btn-primary:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(0, 209, 178, 0.4);
}

.glass-btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.glass-btn-danger {
  background: rgba(255, 56, 96, 0.15);
  border: 1px solid rgba(255, 56, 96, 0.3);
  color: #ff3860;
}

.glass-btn-danger:hover:not(:disabled) {
  background: rgba(255, 56, 96, 0.25);
}

.has-border-top {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.uppercase {
  text-transform: uppercase;
}

.loading-overlay {
  background: rgba(0, 0, 0, 0.8) !important;
  backdrop-filter: blur(5px);
}

.loading-content {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 20px !important;
  padding: 40px !important;
}

.spinner {
  border-top-color: #00d1b2 !important;
}

::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }

@media screen and (max-width: 1024px) {
  .column.is-3 {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    background: rgba(43, 43, 43, 1);
    border-radius: 20px 20px 0 0;
    padding: 20px;
  }
}
</style>
